import { apiEndpoints, api } from "./config";
import { CHAT_API_BASE, WEBCHAT_CONFIG } from "./components/webchatConfig";
import apiClient from "./api/apiClient";
import axios from "axios";


export const authAPI = {
  // Sign up user
  signupUser: async (userData) => {
    try {
      const response = await apiClient.post(
        apiEndpoints.addCustomer,
        {
          companyCustomerName: userData.name,
          companyCustomerPriPhone: userData.phone,
          companyCustomerPriEmail: userData.email,
          password: userData.password,
          companyCustomerCountry: userData.country,
          companyCustomerCity: userData.city,
          companyCustomerAddress1: userData.address1,
          industry: userData.industry,
        },
        {
          headers: { Authorization: `Bearer ${api.authToken}` },
        }
      );

      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },

  // Send email verification OTP
  sendVerificationOTP: async (userData) => {
    try {
      const response = await apiClient.post(
        apiEndpoints.sendVerification,
        {
          companyCustomerPriEmail: userData.email,
          companyCustomerName: userData.name,
          companyCustomerPriPhone: userData.phone,
          uuid: WEBCHAT_CONFIG.uuid,
        },
        {
          headers: { Authorization: `Bearer ${api.authToken}` },
        }
      );

      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },

  // Verify email OTP
  verifyEmailOTP: async (email, otp) => {
    try {
      const response = await apiClient.post(
        apiEndpoints.verifyEmail,
        {
          companyCustomerPriEmail: email,
          otp: otp,
        },
        {
          headers: { Authorization: `Bearer ${api.authToken}` },
        }
      );

      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },

  // Login with email and password
  loginWithPassword: async (email, password) => {
    try {
      const response = await apiClient.post(
        apiEndpoints.customerLogin,
        {
          companyCustomerPriEmail: email,
          password: password,
        },
        { skipAuth: true }
      );

      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },

  // Send login OTP
  sendLoginOTP: async (email, sender) => {
    try {
      const payload = {
        companyCustomerPriEmail: email,
        uuid: WEBCHAT_CONFIG.uuid,
      };

      if (sender) {
        payload.sender = sender;
      }

      const response = await apiClient.post(
        apiEndpoints.sendLoginOtp,
        payload,
        { skipAuth: true }
      );

      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },

  // Login with OTP
  loginWithOTP: async (email, otp) => {
    try {
      const response = await apiClient.post(
        apiEndpoints.loginWithOtp,
        {
          companyCustomerPriEmail: email,
          otp: otp,
        },
        { skipAuth: true }
      );

      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },

  // Forgot Password (Send Reset OTP)
  sendForgotPasswordOTP: async (email) => {
    try {
      const response = await apiClient.post(
        apiEndpoints.forgotPassword,
        {
          companyCustomerPriEmail: email,
        },
        { skipAuth: true }
      );

      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },

  // Verify Reset Password OTP
  verifyResetOTP: async (email, otp) => {
    try {
      const response = await apiClient.post(
        apiEndpoints.verifyResetOtp,
        {
          companyCustomerPriEmail: email,
          otp: otp,
        },
        { skipAuth: true }
      );

      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },

  // Reset Password
  resetPassword: async (email, newPassword, confirmPassword) => {
    try {
      const response = await apiClient.post(
        apiEndpoints.resetPassword,
        {
          companyCustomerPriEmail: email,
          newPassword: newPassword,
          confirmPassword: confirmPassword,
        },
        { skipAuth: true }
      );

      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },

  // Get Profile
  getProfile: async (token) => {
    try {
      const config = {};
      if (token) {
        config.headers = { Authorization: `Bearer ${token}` };
      } else {
        if (!token) config.skipAuth = true;
      }

      const response = await apiClient.get(apiEndpoints.profile, config);

      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },

  // Update Profile
  updateProfile: async (token, profileData) => {
    try {
      const config = {};
      if (token) {
        config.headers = { Authorization: `Bearer ${token}` };
      } else {
        config.skipAuth = true;
      }

      const response = await apiClient.put(
        apiEndpoints.profile,
        profileData,
        config
      );

      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },

  // Change Password
  changePassword: async (token, email, currentPassword, newPassword, confirmPassword) => {
    try {
      const config = {};
      if (token) {
        config.headers = { Authorization: `Bearer ${token}` };
      } else {
        config.skipAuth = true;
      }

      const response = await apiClient.put(
        apiEndpoints.changePassword,
        {
          companyCustomerPriEmail: email,
          currentPassword: currentPassword,
          newPassword: newPassword,
          confirmPassword: confirmPassword,
        },
        config
      );

      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },

  // Add User Role (Chat Integration)
  addUserRole: async (uuid, userId, userRole, authHeader) => {
    try {
      // This targets a different Base URL (CHAT_API_BASE)
      // We can still use axios but maybe a separate call or override baseURL
      // Or just use fetch for this one if it's external/different auth scheme?
      // It uses `authHeader` passed in.

      const response = await axios.post(`${CHAT_API_BASE}/user/add-user-role`, {
        uuid,
        userId,
        userRole
      }, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authHeader}`
        }
      });
      // Note: importing axios directly for this unique call instead of apiClient 
      // to avoid our specific interceptors messing with a different API domain.

      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },
};